(() => {
  if (window.__bpcPdpDiscoveryLoaded) return;
  window.__bpcPdpDiscoveryLoaded = true;

  const normalizeHandle = (value) => String(value || '').trim().toLowerCase();

  const getFamilyHandles = () => {
    const handles = new Set();
    document
      .querySelectorAll('[data-bpc-family-rail] [data-bpc-product-handle]')
      .forEach((item) => {
        const handle = normalizeHandle(item.dataset.bpcProductHandle);
        if (handle) handles.add(handle);
      });
    return handles;
  };

  const normalizeRelated = (root) => {
    if (!(root instanceof Element)) return;

    const list = root.querySelector('[data-bpc-related-list]');
    if (!list) return;

    const current = normalizeHandle(root.dataset.bpcCurrentProductHandle);
    const familyHandles = getFamilyHandles();
    const seen = new Set();
    const cap = Math.max(1, Number(root.dataset.bpcRelatedCap) || 8);
    let kept = 0;

    list.querySelectorAll('[data-bpc-product-handle]').forEach((item) => {
      const handle = normalizeHandle(item.dataset.bpcProductHandle);
      const remove =
        !handle ||
        handle === current ||
        familyHandles.has(handle) ||
        seen.has(handle) ||
        kept >= cap;

      if (remove) {
        item.remove();
        return;
      }

      seen.add(handle);
      kept += 1;
    });

    root.hidden = kept === 0;
    root.dataset.bpcRelatedNormalized = String(kept);
  };

  const normalizeAll = () => {
    document.querySelectorAll('[data-bpc-related-recommendations]').forEach(normalizeRelated);
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      normalizeAll();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener('bpc:related-products:ready', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
